module.exports = __webpack_public_path__ + "img/music-test-icon2.da6d379f.png";